module.exports = __webpack_public_path__ + "static/media/chocolate-box-silver.cfd908e1.jpg";